import { createI18n } from 'vue-i18n'
import store from '~/store'

const i18n = createI18n({
  locale: 'ar',
  fallbackLocale: 'ar',
  messages: {},
  legacy: false,
  globalInjection: true
})

/**
 * @param {String} locale
 */
export async function loadMessages (locale) {
  if (Object.keys(i18n.global.getLocaleMessage(locale)).length === 0) {
    const messages = await import(/* webpackChunkName: '' */ `~/lang/${locale}.json`)
    i18n.global.setLocaleMessage(locale, messages.default)
  }

  if (i18n.global.locale.value !== locale) {
    i18n.global.locale.value = locale
  }

  // Remove all language and direction classes
  document.querySelector('body').classList.remove('ltr', 'rtl', 'ar', 'en');

  // Add current language class
  document.querySelector('body').classList.add(i18n.global.locale.value);

  // Arabic is RTL, English is LTR
  if (i18n.global.locale.value === 'ar') {
    document.querySelector('body').classList.add('rtl');
  } else {
    document.querySelector('body').classList.add('ltr');
  }

}

// Initialize i18n with initial locale messages
export const initI18n = async () => {
  await loadMessages(store.getters['lang/locale'])
}

export default i18n
